import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const MAPBOX_TOKEN =
  "pk.eyJ1IjoiZGlsZWVwc2tiMzUwIiwiYSI6ImNtOXR4bnRqYTAzcGYyanExOXc2aWZtdnkifQ.mrGKETNvcm876Y6AU__wfA";

function StartSelectMapBox({
  onSelect,
}: {
  onSelect: (location: any) => void;
}) {
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const selectedRef = useRef(false); // 👈 Track if user has selected something

  useEffect(() => {
    if (!query || selectedRef.current) {
      selectedRef.current = false;
      return;
    }

    const fetchSuggestions = async () => {
      try {
        const res = await axios.get(
          `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(query)}.json`,
          {
            params: {
              access_token: MAPBOX_TOKEN,
              // country: "us",
              limit: 5,
            },
          },
        );
        setSuggestions(res.data.features);
      } catch (error) {
        console.error("Failed to fetch suggestions", error);
      }
    };

    const timeout = setTimeout(fetchSuggestions, 300); // Debounce API calls
    return () => clearTimeout(timeout);
  }, [query]);

  return (
    <div className="mb-3">
      <input
        className="border p-2 w-full"
        type="text"
        placeholder="Enter Start Location"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
        }}
      />
      {suggestions.length > 0 && (
        <ul className="bg-white border rounded shadow mt-1 max-h-60 overflow-y-auto z-10 relative">
          {suggestions.map((place: any) => (
            <li
              key={place.id}
              className="p-2 hover:bg-gray-100 cursor-pointer"
              onClick={() => {
                onSelect({
                  name: place.place_name,
                  lat: place.center[1],
                  lng: place.center[0],
                });
                selectedRef.current = true; // 👈 Prevent refetch
                setQuery(place.place_name);
                setSuggestions([]); // 👈 Close dropdown
              }}
            >
              {place.place_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default StartSelectMapBox;
